<template>
  <div class="main col-xs-12">
    <AppMessages v-bind:message="this.message"
                 v-bind:show="this.show"
                 v-bind:type="this.messageType" />
    <h1>Product Parameters</h1>

    <AppProductSearch ref="child" />


    <form v-show="product">

      <label class="label">Test type</label>
      <select v-model="newtest.type">
        <option v-bind:key="getUniqueKey(testtype, index)"
                v-for="(testtype, index) in testtypes"
                :value="testtype"
                :selected="index === 0">
          {{ testtype }}
        </option>
      </select>


      <label class="label label--leftmargin">Description</label>
      <input class="input"
             v-model="newtest.description"
      ref="newdescription"/>

      <label class="label label--leftmargin">Lower limit</label>

      <input class="input"
             v-bind:class="{'form-group--error':newtest.errors.lower}"
             v-model="newtest.lower"
             ref="newlower" />

      <label class="label label--leftmargin">Upper limit</label>
      <input class="input"
             v-bind:class="{'form-group--error':newtest.errors.upper}"
             v-model="newtest.upper"
             ref="newupper" />

      <button class="button button--alt button--marginleft" @click="addTest" type="button">
        Add
        test
      </button>
      <div style="padding-top:5px">
        <p v-if="newtest.errors.lower||newtest.errors.upper">
          The following validation error(s) were
          encountered during processing. Please fix before continuing.
        </p>
        <span class="error" v-bind:class="{'inline-group--error':newtest.errors.lower}">
          {{
            newtest.errors.lower
          }}
        </span>
        <span class="error" v-bind:class="{'inline-group--error':newtest.errors.upper}">
          {{
            newtest.errors.upper
          }}
        </span>
      </div>

    </form>

    <div v-show="product">
      <template>
        <form>
          <table class="table">
            <thead>
              <tr>
                <th></th>
                <th class="table__header">Product code</th>
                <th class="table__header">Parameter no</th>
                <th class="table__header">Test type</th>
                <th class="table__header">Description</th>
                <th class="table__header">Lower</th>
                <th class="table__header">Upper</th>
              </tr>
            </thead>
            <tbody v-if="tests.length">
              <tr v-bind:key="getUniqueKey(test.id, index)" v-for="(test, index) in tests">
                <td class="table__col">
                  <div v-if="!test.edit">
                    <a v-on:click="editTable(test)" class="table__link">Edit</a>
                    <a v-on:click="deleteTest(test.id)" class="table__link">Delete</a>
                  </div>
                  <div v-if="test.edit">
                    <a v-on:click="updateTest(test.id)" class="table__link">Update</a>
                    <a v-on:click="editTable(test)" class="table__link">Cancel</a>
                  </div>
                </td>
                <td class="table__col">{{ test.product }}</td>
                <td class="table__col">
                  <span v-if="!test.edit">{{ test.no }}</span>
                  <input class="input" v-if="test.edit" v-model="test.no" />
                </td>
                <td class="table__col">
                  <span v-if="!test.edit">{{ test.type }}</span>
                  <select class="form-block"
                          v-bind:key="getUniqueKey('test.type', 'update')"
                          @change="onTestTypeChanged(test)"
                          v-if="test.edit"
                          v-model="test.type">
                    <option v-bind:key="type"
                            v-for="type in testtypes"
                            :value="type"
                            :selected="type == test.type ? 'selected' : ''">
                      {{ type }}
                    </option>
                  </select>
                </td>
                <td class="table__col">
                  <span v-if="!test.edit">{{ test.description }}</span>
                  <input v-if="test.edit" class="input form-block" v-model="test.description" />
                </td>
                <td class="table__col">
                  <span v-if="!test.edit">{{ test.lower }}</span>
                  <input v-if="test.edit && (test.type === '>' || test.type === 'R')"
                         class="input form-block"
                         v-bind:class="{'form-group--error':test.errors.lower}"
                         v-model="test.lower" />
                  <div v-if="test.errors.lower" class="error">{{ test.errors.lower }}</div>
                </td>
                <td class="table__col">
                  <span v-if="!test.edit">{{ test.upper }}</span>
                  <input v-if="test.edit && (test.type === '<' || test.type === 'R')"
                         class="input form-block"
                         v-bind:class="{'form-group--error':test.errors.upper}"
                         v-model="test.upper" />
                  <div v-if="test.errors.upper" class="error">{{ test.errors.upper }}</div>
                </td>
              </tr>
            </tbody>
            <tbody v-else>
              <tr>
                <td colspan="7" class="table__col">No parameters found</td>
              </tr>
            </tbody>
          </table>
          <template v-show="tests.length">

            <div class="form-group">
              <input id="copy-product" class="checkbox" type="checkbox" />
              <label for="copy-product"
                     class="label label--alt-inline"
                     v-on:click="copyTest()">Copy to another product</label>

              <AppProductSearch v-show="copy" ref="child2" />

              <button v-show="copy && productcopy"
                      class="button button--alt"
                      type="button"
                      @click="updateCopyList()">
                Select
              </button>

              <button v-show="copylist && copylist.length" class="button button--alt"
                      @click="copyParameters" type="button">
                Copy
              </button>

              <ul>
                <li v-bind:key="product.code" v-for="product in copylist">
                  {{ product.code }} <a v-on:click="updateCopyList(product)" class="table__link">(Remove)</a>
                  <span v-if="product.hasParameters" style="color:red;">There is already parameters for this product, are you sure you want to continue?</span>
                </li>
              </ul>


            </div>
          </template>
        </form>

        <form>
          <div class="form-group">
            <label class="label label--alt-inline">Certificate type</label>
            <selectize v-model="certtype" :settings="selectizeSettings">
              <option value="A">A</option>
              <option value="C">C</option>
            </selectize>

            <label class="label label--alt-inline">Supplier / Surfac</label>
            <selectize v-model="supplier" :settings="selectizeSettings">
              <option value="Supplier">Supplier</option>
              <option value="Surfac">Surfac</option>
            </selectize>

            <button class="button button--alt" @click="updateType" type="button"
                    v-bind:disabled="!certtype || !supplier">
              Update Type
            </button>
          </div>
        </form>

      </template>
    </div>
  </div>
</template>

<script>
  import Selectize from 'vue2-selectize';
  import axios from 'axios';
  import AppMessages from '@/components/AppMessages/AppMessages.vue';
  import AppProductSearch from '@/components/AppProductSearch/AppProductSearch.vue';
  import Validation from '../validation';
  import SearchObjects from '../mixins/SearchObjects';

  export default {
    name: 'parameters',
    components: {
      AppProductSearch,
      Selectize,
      AppMessages,
    },
    mixins: [SearchObjects],
    data() {
      return {
        selectizeSettings: {
          maxOptions: 10000,
          sortField: [{ field: 'value', direction: 'asc' }, { field: '$score' }],
          allowEmptyOption: false,
          placeholder: 'Select value'
        },
        product: '',
        tests: '',
        newtest: {
          type: '',
          description: '',
          upper: '',
          lower: '',
          errors: {}
        },
        certtype: '',
        supplier: '',
        testtype: '',
        productcopy: '',
        copy: '',
        copylist: [],
        message: '',
        messageType: '',
        testtypes: ['<', '>', '=', 'R', 'D', 'T', 'CoO'],
        show: false,
      };
    },
    mounted() {
      this.$watch(
        '$refs.child.selectedProduct',
        (newValue, oldValue) => (this.product = newValue.code)
      );
      this.$watch(
        '$refs.child2.selectedProduct',
        (newValue, oldValue) => (this.productcopy = newValue.code)
      );
    },
    computed: {
      products() {
        return this.$store.state.products;
      },
      newtype() {
        return this.newtest.type;
      },
    },
    created() {
      this.newtest.type = '>';
    },
    watch: {
      product(newValue, oldValue) {

        this.certtype = null;
        this.supplier = null;
        this.tests = [];
        this.productcopy = null;
        this.copylist = [];
        this.copy = false;
        this.newtest = {
          type: '>',
          description: '',
          upper: '',
          lower: '',
          errors: {}
        };

        if (!newValue) {
          return;
        }

        this.loadProduct();
      },
      newtype(value) {
        const inputUpper = this.$refs.newupper;
        const inputLower = this.$refs.newlower;
        const inputDescription = this.$refs.newdescription

        inputUpper.disabled = false;
        inputLower.disabled = false;

        this.newtest.errors = {};

        this.newtest.upper = '';
        this.newtest.lower = '';

        this.setDefaultForType(value, inputUpper, inputLower, inputDescription);
      }
    },
    methods: {
      setDefaultForType(value, inputUpper, inputLower, inputDescription) {
        switch (value) {
          case '<':
            inputLower.disabled = true;
            break;
          case '>':
          case '=':
            inputUpper.disabled = true;
            break;
          case 'D':
            inputUpper.disabled = true;
            inputLower.disabled = true;
            this.newtest.lower = 'DD/MM/YYYY';
            break;
          case 'T':
            inputUpper.disabled = true;
            inputLower.disabled = true;
            break;
          case 'CoO':
            this.newtest.description = 'Country of Origin';
            inputDescription.disabled = true;
            inputUpper.disabled = true;
            inputLower.disabled = true;
            break;
          default:
          // do nothing
        }
      },
      addTest() {
        if (!this.validateTest(this.newtest)) {
          return;
        }

        this.message = '';
        this.messageType = '';
        this.show = false;
        this.$Progress.start();

        const url = `/products/${this.product}/parameters`;
        axios
          .post(url, {
            type: this.newtest.type,
            description: this.newtest.description,
            upperLimit: this.newtest.upper,
            lowerLimit: this.newtest.lower,
          })
          .then(() => {
            this.message = 'Test added successfully';
            this.messageType = 'message message--success';
            this.show = true;
            this.$Progress.finish();

            this.newtest.description = '';
            this.newtest.upper = '';
            this.newtest.lower = '';
            this.newtest.errors = {};

            // force a rebind to set any defaults
            const inputUpper = this.$refs.newupper;
            const inputLower = this.$refs.newlower;
            const inputDescription = this.$refs.newdescription;
            this.setDefaultForType(this.newtest.type, inputUpper, inputLower, inputDescription);

            this.loadProduct();
          })
          .catch((e) => {
            this.message = `Test not added: ${Validation.parseExceptionMessage(e)}`;
            this.messageType = 'message message--error';
            this.show = true;
            this.$Progress.fail();
          });
      },
      deleteTest(testId) {
        // eslint-disable-next-line
        if (!window.confirm('Do you really want to delete?')) {
          return;
        }

        this.message = '';
        this.messageType = '';
        this.show = false;
        this.$Progress.start();

        const url = `/products/${this.product}/parameters/${testId}`;
        axios.delete(url)
          .then(() => {
            this.message = 'Test deleted successfully';
            this.messageType = 'message message--success';
            this.show = true;
            this.$Progress.finish();

            this.loadProduct();
          })
          .catch((e) => {
            this.message = `Test not deleted: ${Validation.parseExceptionMessage(e)}`;
            this.messageType = 'message message--error';
            this.show = true;
            this.$Progress.fail();
          });
      },
      editTable(test) {

        if (test.edit) {
          if (test.errors.lower) {
            test.lower = '';
          }

          if (test.errors.upper) {
            test.upper = '';
          }
        }

        // eslint-disable-next-line
        test.edit = !test.edit;
      },
      updateTest(id) {
        const test = this.tests.filter(x => x.id === id)[0];

        if (!this.validateTest(test)) {
          return;
        }

        this.message = '';
        this.messageType = '';
        this.show = false;
        this.$Progress.start();

        var parameter = {
          type: test.type,
          description: test.description,
          lowerLimit: test.lower,
          upperLimit: test.upper,
          number: test.no
        }

        const url = `/products/${this.product}/parameters/${test.id}`;
        axios.post(url, parameter).then(() => {
          test.edit = false;
          this.message = 'Test updated successfully';
          this.messageType = 'message message--success';
          this.show = true;
          this.$Progress.finish();
        })
          .then(() => {
            this.loadProduct();
          })
          .catch((e) => {
            this.message = `Test not updated: ${Validation.parseExceptionMessage(e)}`;
            this.messageType = 'message message--error';
            this.show = true;
            this.$Progress.fail();
          });
      },
      copyTest() {
        this.copy = !this.copy;
        if (!this.copy) {
          this.copylist = [];
          this.productcopy = '';
        }
      },
      updateType() {
        this.message = '';
        this.messageType = '';
        this.show = false;
        this.$Progress.start();

        if (!this.isProductSelected()) {
          return;
        }

        if (this.certtype === '' || this.supplier === '') {
          this.showError('Certificate type and supplier/surfac are required');
          return;
        }

        const url = `/products/${this.product}`;
        axios.post(url, {
          certType: this.certtype,
          supplierOrSurfac: this.supplier,
        })
          .then(() => {
            this.$Progress.finish();
            this.message = 'Certificate type updated successfully';
            this.messageType = 'message message--success';
            this.show = true;
          })
          .catch((e) => {
            this.showError(`Product failed to update: ${Validation.parseExceptionMessage(e)}`);
          });
      },
      updateCopyList(product) {
        if (!product) {
          if (this.copylist.find(e => e.code == this.productcopy)) {
            alert('This product has already been selected. Please select a different product.');
            return;
          }

          const productCode = this.productcopy;
          this.getProduct(productCode).then((p) => {
            this.copylist.push({
              code: this.productcopy,
              hasParameters: p.parameters != null,
            });
          });
        } else {
          const item = this.searchObjects(this.copylist, 'code', product);
          const index = this.copylist.indexOf(item);
          this.copylist.splice(index, 1);
        }
      },
      copyParameters() {
        this.$Progress.start();

        const copyTo = [];
        for (let i = 0; i < this.copylist.length; i++) {
          copyTo.push(this.copylist[i].code);
        }

        const url = `products/${this.product}/copy-parameters`;
        axios.post(url, { ProductCodes: copyTo })
          .then((r) => {
            this.showSuccess('Parameters have been copied');
            this.copylist = [];
            this.productcopy = '';
          })
          .catch((e) => {
            this.showError(`Product paramaters could not be copied: ${e.response.data.join(', ')}`);
          })
          .finally(() => this.$Progress.finish());
      },
      isProductSelected() {
        if (this.product !== '') {
          return true;
        }

        this.showError('Select a product');
        return false;
      },
      showError(msg) {
        this.$Progress.fail();
        this.message = msg;
        this.messageType = 'message message--error';
        this.show = true;
      },
      showSuccess(msg) {
        this.message = msg;
        this.messageType = 'message message--success';
        this.show = true;
      },
      loadProduct() {

        const productCode = this.product;

        this.getProduct(productCode).then((product) => {
          this.certtype = product.certType;
          this.supplier = product.supplierOrSurfac;
          this.tests = [];

          const { parameters } = product;

          if (parameters) {
            const productTests = [];

            for (let i = 0; i < parameters.length; i++) {
              const parameter = parameters[i];

              productTests.push({
                id: parameter.id,
                no: parameter.number,
                product: productCode,
                type: parameter.type,
                description: parameter.description,
                lower: parameter.lowerLimit,
                upper: parameter.upperLimit,
                errors: {},
                edit: false,
              });
            }


            this.tests = productTests;
          }
        });

        // const productCode = this.product;
        //
        // this.getProduct(productCode).then((product) => {
        //   this.certtype = product.certType;
        //   this.supplier = product.supplierOrSurfac;
        //   this.tests = [];
        //
        //   const { parameters } = product;
        //
        //   if (parameters) {
        //     const productTests = [];
        //
        //     for (let i = 0; i < parameters.length; i++) {
        //       const parameter = parameters[i];
        //
        //       productTests.push({
        //         id: parameter.id,
        //         no: parameter.number,
        //         product: productCode,
        //         type: parameter.type,
        //         description: parameter.description,
        //         lower: parameter.lowerLimit,
        //         upper: parameter.upperLimit,
        //         errors: {},
        //         edit: false,
        //       });
        //     }
        //
        //     this.tests = productTests;
        //   }
        // });
      },
      getProduct(productCode) {
        if (!productCode) {
          return null;
        }

        this.$Progress.start();

        const url = `/products/${productCode}`;
        return axios.get(url)
          .then((r) => {
            this.$Progress.finish();
            return r.data;
          })
          .catch((e) => {
            this.$Progress.fail();
            this.showError('Product details could not be loaded');
            return null;
          });
      },
      getUniqueKey(prefix, index) {
        return `${prefix}_${index}`;
      },
      onTestTypeChanged(test) {
        test.lower = null;
        test.upper = null;
        switch (test.type) {
          case '<':
            test.lower = null;
            break;
          case '>':
          case '=':
            test.upper = null;
            break;
          case 'D':
            test.lower = 'DD/MM/YYYY';
            break;
          case 'CoO:':
            test.description = 'Country Of Origin'
            break;
          default:
            break;
        }
      },
      validateTest(test) {

        test.errors = {
          lower: null,
          upper: null,
        };

        var hasErrors = false;

        if (test.type === 'T' || test.type === 'D') {
          return true;
        }

        if (test.type === '=' && !test.lower) {
          test.errors.lower = 'Value is required';
          hasErrors = true;
        }

        if ((test.type === '>' || test.type === 'R') && !parseFloat(test.lower)) {
          test.errors.lower = 'Lower limit must be a number';
          hasErrors = true;
        }

        if ((test.type === '<' || test.type === 'R') && !parseFloat(test.upper)) {
          test.errors.upper = 'Upper limit must be a number';
          hasErrors = true;
        }

        return !hasErrors;
      }
    },
  };
</script>
